@wangmx
该组件用户给锁定的柜员解锁
<template>
  <div class="content">
    <div class="mainBox">
      <div class="file_head">
        <div class="file_head_left_icona"></div>
        <div class="file_head_left_iconb"></div>
        <p class="file_head_left_text">解锁账户</p>
      </div>
      <div class="file_search">
        <el-form :model="{}">
          <k-input id="userName" placeholder="请输入需解锁的账号" :value.sync="userName"  validtype="numchar[0,255]|on-change"  />
        </el-form>
        <div class="file_search_content_icon" @click="delVerifyUser">
          <span>解锁</span>
        </div>
         <div class="file_search_content_icon" @click="gotoTest">
          <span>接口调用</span>
        </div>
      </div>
    </div>
  
  </div>
</template>
<script>
import kInput from "@/components/baseUI/kInput";

export default {
  components: {
    kInput,
  },
  data () {
    return {
      userName: "", //需解锁的账户名
    };
  },
  mounted () {
     
  },
  methods: {
    //解锁账户
    async delVerifyUser () {
      let that = this;
      if(that.userName){
        that.myLoading({
          loadingText: "数据处理中，请稍后...",
          autoHide: false
        });
        return that.$syscfg.K_Request("F0000005", {
          userName: that.userName,
        }).then(res => {
          if(res && res.Code == "0"){
            that.alert(res.Msg);
          }else{
            consoleError("F0000005调用返回结果",res);
            that.alert("操作失败，请联系管理员！");
          }
        }).catch(err=>{
          consoleError("F0000005调用失败",err);
          that.alert("接口调用失败，请联系管理员！");
        }).finally(()=>{
          that.userName = "";
          that.myLoading({
            showLoading: false
          });
        });
      }else{
        that.alert("请输入需要解锁的账号！");
      }
    },
    gotoTest (){
      this.$router.push({ name: "test" });
    }
  }
};
</script>
 
<style scoped lang="less">
.content {
  margin-top: 26px !important;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .mainBox {
    width: 1250px;
    background: #ffffff;
    border-radius: 3px;
    z-index: 10;
    .file_head {
      width: 1200px;
      height: 60px;
      margin-left: 25px;
      border-bottom: #e8e8e8 1px solid;
      display: flex;
      align-items: center;
      position: relative;
      .file_head_left_icona {
        width: 3px;
        height: 20px;
        background: #cfa972;
        border-radius: 1px;
        margin-left: 10px;
      }
      .file_head_left_iconb {
        width: 3px;
        height: 14px;
        background: #cfa972;
        border-radius: 1px;
        margin-left: 5px;
        margin-top: 6px;
      }
      .file_head_left_text {
        height: 15px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;

        margin-left: 6px;
      }
    }
    .file_search {
      width: 1250px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      .file_search_content_icon {
        width: 100px;
        height: 41px;
        background: linear-gradient(30deg, #e5c489, #dcb369);
        border-radius: 5px;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
      }
      .el-form{
        margin-top: 23px;
        .el-form-item{
          .el-form-item__content{
            margin-top: 3px;
          }
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/unlockAccount/unlockAccount.vue